import styled, { css } from 'styled-components'
import {
  DIVIDER_COLOR,
  SECONDARY_TEXT,
  WHITE,
  DARK_PURPLE,
  BLIND_PURPLE_RGB,
  DARK_DIVIDER,
} from 'constants/colors'
import { Flex } from 'components/common/styles'

export const JobItemContainer = styled.div<{ isActive: boolean }>`
  padding: 0 16px;
  border-bottom: 1px solid
    ${({ isActive }) => (isActive ? DARK_DIVIDER : DIVIDER_COLOR)};
  padding-bottom: 11px;
`

export const CreatedBy = styled(Flex)`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  padding: 12px 16px;

  > span {
    font-weight: 400;
  }
`

export const StyledPaper = styled.div<{ isActive: boolean }>`
  padding: 16px 0 0 !important;
  margin-bottom: 8px;
  border: 1px solid ${DIVIDER_COLOR};
  border-radius: 8px;
  background-color: ${WHITE};
  color: ${SECONDARY_TEXT};
  box-shadow: rgba(${BLIND_PURPLE_RGB}, 0.25) 0px 4px 13px !important;

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${DARK_PURPLE};
      color: ${WHITE};
    `}
`
